// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"677330ab","703":"051cf419","787":"2340d1fa"}[chunkId] + ".chunk.js";
};